import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleCountry',
		endpoint: '/vehicle/country',
        items: [],
    },
    actions: {
		load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}